<template>
    <v-flex xs12 pa-2 mt-3>
        <v-card
                class="mx-auto"
        >
            <v-sheet
                    class="v-sheet--offset mx-auto pa-4"
                    :color="color || 'secondary'"
                    elevation="12"
                    max-width="calc(100% - 32px)"
            >
                <v-sparkline
                        :labels="allEvents.labels"
                        :value="allEvents.values"
                        color="white"
                        line-width="1"
                        padding="25"
                ></v-sparkline>
            </v-sheet>

            <v-card-text class="pt-0">
                <div class="title font-weight-light mb-2">{{title}}</div>
                <div class="subheading font-weight-light grey--text">{{subtitle}}</div>
                <v-divider class="my-2"></v-divider>
                <v-icon
                        class="mr-2"
                        small
                        v-if="last"
                >
                    mdi-clock
                </v-icon>
                <span v-if="last" class="caption grey--text font-weight-light">
                    último registro: {{last}}
                </span>
            </v-card-text>
        </v-card>
    </v-flex>

</template>
<script>
    export default {
        props: ['color', 'title', 'subtitle', 'additionalText', 'labels', 'values'],
        data: () => ({
        }),
        computed: {
            allEvents(){

                var vm = this
                if(!vm.labels || !vm.values) return {
                    labels: [],
                    values: []
                }

                var currentEvents = vm.sortedEvents.slice()
                var currentValues = vm.values.slice()

                const threeMonthsAgo = vm.$moment().subtract(3, 'months').format('DD-MM-YYYY')
                const today = vm.$moment().format('DD-MM-YYYY')

                const includesThreeMonthsAgo = currentEvents.find(event => event === threeMonthsAgo) !== undefined
                const includesToday = currentEvents.find(event => event === today) !== undefined

                if(!includesThreeMonthsAgo){
                    currentEvents.unshift(threeMonthsAgo)
                    currentValues.unshift(0)
                }

                if(!includesToday){
                    currentEvents.push(today)
                    currentValues.push(0)
                }

                return {
                    labels: currentEvents.map(date=> vm.$moment(date, 'DD-MM-YYYY').format('D MMM')),
                    values: currentValues
                }

            },
            sortedEvents(){
                var vm = this
                if(!vm.labels) return []
                const array = vm.labels
                return array.sort((a,b) => vm.$moment(a).format('YYYYMMDD') - vm.$moment(b).format('YYYYMMDD'))
            },

            last(){
                var vm = this
                if(!vm.labels || vm.labels.length === 0) return null
                return vm.$moment(vm.labels[vm.labels.length-1], 'DD-MM-YYYY').fromNow()
            }
        }
    }
</script>

<style scoped>
    .v-sheet--offset {
        top: -24px;
        position: relative;
    }
</style>